var dictionary = {
    messages: {
        decimal: function (e, i) {
            void 0 === i && (i = []);
            var n = i[0];
            return void 0 === n && (n = "*"), "A mezőnek numerikusnak kell lennie, és tartalmazhat " + ("*" === n ? "" : n) + " tizedes számot."
        },
        max: function (e, i) {
            return e + " nem haladhatja meg a " + i[0] + " karaktert."
        },
        max_value: function (e, i) {
            return "Adja meg azt az értéket, ami kisebb mint " + i[0] + "."
        },
        min_value: function () {
            return "A bemeneti értéknek 0-nál nagyobbnak kell lennie."
        },
        numeric: function (e) {
            return "A(z)" + e + " értéke szám kell, hogy legyen."
        },
        required: function (e) {
            return "Mezőbevitel szükséges!"
        }
    },
    attributes: {}
};

export {
    dictionary
};